var reviewAccomodation = {
  options: {
    // global options
  },

  selectors: {
    review_item: ".js-accomodation-review-item",
    delete_review_button: ".js-accomodation-delete-review",
  },

  init: function () {
    const self = this;

    jQuery(self.selectors.delete_review_button).on("click", function (event) {
      event.preventDefault();
      self.deleteReview(jQuery(this));
    });
  },

  deleteReview: function (el_review_button) {
    const self = this;

    const el_review_item = el_review_button.closest(self.selectors.review_item);
    const id = el_review_item.data("id");

    jQuery.ajax({
      dataType: "json",
      url: sikmoVars.ajax_url,
      method: "post",
      data: {
        action: "review",
        review_action: "delete",
        review_id: id,
      },
    })
      .done(function (data) {
        if (typeof data.status === "string" && data.status == "success") {
          el_review_item.remove();
        }
      })
      .fail(function (jqXHR, textStatus, errorThrown) {
        if (jqXHR.responseJSON?.data) {
          alert(jqXHR.responseJSON.data);
        }
      });
  }
}

// Export
export { reviewAccomodation };